import { I18N } from 'aurelia-i18n';
import { AccountPaymentItem } from '../../../../models/account-payment-item';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class EnteredAmountGreaterThanZeroRule implements IValidationRule {
	constructor(private i18n: I18N, private items: AccountPaymentItem[]) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		let greaterThanZero: boolean = true;

		this.items.forEach((i: AccountPaymentItem) => {
			if (!greaterThanZero) {
				return;
			}

			if (i.isSelected) {
				let parsedAmount: number = parseFloat(i.enteredAmount);
				if (isNaN(parsedAmount) || parsedAmount <= 0) {
					greaterThanZero = false;
				}
			}
		});

		result.isValid = greaterThanZero;

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('paymentAmountMustBeGreaterThanZero', 'Payment Amount must be greater than 0.');
		}

		return result;
	}
}
